import { useId, type ReactNode } from 'react';

/**
 * A titled panel. The heading and the section are associated, so a screen reader's
 * landmark list reads as the page's outline rather than as a run of unnamed regions.
 */

export interface CardProps {
  title: string;
  description?: string;
  /** Shown at the end of the header row: a badge, or a small action. */
  aside?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

export function Card({ title, description, aside, footer, children }: CardProps): ReactNode {
  const id = useId();
  return (
    <section className="card" aria-labelledby={id}>
      <header className="card-header">
        <div className="row">
          <h2 id={id}>{title}</h2>
          {aside !== undefined && <span className="push-right">{aside}</span>}
        </div>
        {description !== undefined && <p>{description}</p>}
      </header>
      <div className="card-body">{children}</div>
      {footer !== undefined && <footer className="card-footer">{footer}</footer>}
    </section>
  );
}
